import { render, staticRenderFns } from "./addDImodel.vue?vue&type=template&id=55a4b14f&scoped=true"
import script from "./addDImodel.vue?vue&type=script&lang=js"
export * from "./addDImodel.vue?vue&type=script&lang=js"
import style0 from "./addDImodel.vue?vue&type=style&index=0&id=55a4b14f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a4b14f",
  null
  
)

export default component.exports